
import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import PersonalCenter from '@/components/PersonalCenter'
import ErrorMessage from '@/components/ErrorMessage'
import StaffLogin from '@/components/StaffLogin'
import DiamondSearch from '@/components/DiamondSearch'
import DiamondList from '@/components/DiamondList'
import MyCar from '@/components/MyCar'
import MyOrder from '@/components/MyOrder'
import Home from '@/components/Home'
import FeedBack from '@/components/FeedBack'
import Calculator from '@/components/Calculator'
import StaffRegister from '@/components/StaffRegister'
import DiaWeb from '@/components/DiaWeb'
import ChangePass from '@/components/ChangePass'
import SelectShop from '@/components/SelectShop'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/:Uid',
            redirect: '/Home/:Uid'
        },
        {
            path: '/Home/:Uid',
            name: 'Home',
            component: Home
        },
        {
            path: '/StaffLogin/:Uid',
            name: 'StaffLogin',
            component: StaffLogin
        },
        {
            path: '/DiamondSearch/:Uid',
            name: 'DiamondSearch',
            component: DiamondSearch
        },
        {
            path: '/DiamondList/:Uid',
            name: 'DiamondList',
            component: DiamondList
        },
        {
            path: '/MyCar/:Uid',
            name: 'MyCar',
            component: MyCar
        },
        {
            path: '/MyOrder/:Uid',
            name: 'MyOrder',
            component: MyOrder
        },
        {
            path: '/FeedBack/:Uid',
            name: 'FeedBack',
            component: FeedBack
        },
        {
            path: '/Calculator/:Uid',
            name: 'Calculator',
            component: Calculator
        },
        {
            path: '/StaffRegister/:Uid',
            name: 'StaffRegister',
            component: StaffRegister
        },
        {
            path: '/ChangePass/:Uid',
            name: 'ChangePass',
            component: ChangePass
        },
        {
            path: '/DiaWeb/:Uid',
            name: 'DiaWeb',
            component: DiaWeb
        },
        {
            path: '/SelectShop/:Uid',
            name: 'SelectShop',
            component: SelectShop
        },
        {
            path: '*',
            name: 'ErrorMessage',
            component: ErrorMessage,
            children: [
                { path: 'ErrorEcho', component: ErrorMessage },
                { path: 'ErrorEcho/:Uid', component: ErrorMessage },
                { path: 'ErrorEcho/:Uid/:ShareId', component: ErrorMessage }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js